import { useContext, useEffect, useState } from 'react'

import IconButton from '@material-ui/core/IconButton'
import { AddIcCall, Delete, MailOutline } from '@material-ui/icons'
import { EditContext } from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import BasicTable from 'Components/UI/Atoms/BasicTable'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

import { editFields } from './Fields'

const Contact = ({ data, onDataChange, empresaId }) => {
  const [edit] = useContext(EditContext)
  const [isLoading, setIsLoading] = useState(false)
  const [formEdit, setFormEdit] = useState(data.clientContact)
  const [selectedRow, setSelectedRow] = useState(null)
  const {
    state: paymentDetail,
    setOpen: setOpenPaymentDetail,
    setClose: setClosePaymentDetail,
  } = SetState()

  const createDismissableSnackbar = useCustomSnackbar()

  useEffect(() => {
    setFormEdit(data.clientContact)
  }, [data.clientContact])

  // async function apiCall(id) {
  //     await interfaces.salesSuppliers
  //     .infoOneSupplier(id)
  //     .then((res) => {
  //       setFormEdit({
  //         data: res.data.details
  //       })
  //     })
  //   }
  //   !formEdit && apiCall()

  async function deleteDetail(key) {
    setIsLoading(true)
    const body = { concepto: key }
    await interfaces.salesClients
      .deleteContactInformation(data.infoClient.id, empresaId, body)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        deleteItem(key)
      })
    setIsLoading(false)
  }

  const deleteItem = (key) => {
    const updatedForm = { ...formEdit, [key]: '' }

    setFormEdit(updatedForm)

    onDataChange('clientContact', updatedForm)
  }

  const iconDelete = (key, value) => (
    <IconButton
      onClick={(event) => {
        event.stopPropagation()
        deleteDetail(key)
      }}
      disabled={key === 'telefono1' || !value}
    >
      <Delete />
    </IconButton>
  )

  const onClickRow = (row) => {
    if (!edit) return
    setSelectedRow(row)
    setOpenPaymentDetail(true)
  }

  const handleChangeItem = (name, value) => {
    setSelectedRow((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  const editItem = () => {
    setIsLoading(true)

    const updatedForm = { ...formEdit }

    const keyToUpdate = selectedRow.realKey

    updatedForm[keyToUpdate] = selectedRow.descripcion

    setFormEdit(updatedForm)

    onDataChange('clientContact', updatedForm)

    setTimeout(() => {
      setIsLoading(false)
      setClosePaymentDetail()
    }, 500)
  }

  const getIcon = (key) => {
    const k = key.toLowerCase()
    if (k.includes('mail')) return <MailOutline style={{ fontSize: 18, marginRight: 8 }} />
    if (k.includes('tel') || k.includes('cel'))
      return <AddIcCall style={{ fontSize: 18, marginRight: 8 }} />
    return null
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          margin: '2rem',
          cursor: edit ? 'pointer' : '',
          overflow: 'scroll',
        }}
      >
        <BasicTable
          col={[
            { title: 'Concepto', style: { width: '150px' } },
            { title: 'Descripción', style: { width: '250px' } },
            { title: '', style: { width: '10px', display: 'none' } },
            { title: '', style: { width: '60px', marginRight: '20px' } },
          ]}
          size="small"
          rows={Object.entries(formEdit).map(([key, value]) => ({
            concepto: (
              <div style={{ display: 'flex' }}>
                {getIcon(key)}
                {key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()}
              </div>
            ),
            descripcion: value,
            realKey: key,
            action: iconDelete(key, value),
          }))}
          onClickRow={onClickRow}
        />
      </div>

      <DialogComponent
        open={paymentDetail.open}
        title="Editar información de contacto"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        handleclose={setClosePaymentDetail}
        widthLarge="500px"
        children={
          selectedRow ? (
            <InputsWithoutValidate
              fields={editFields(selectedRow, handleChangeItem, getIcon)}
              spacing={2}
            />
          ) : null
        }
        actions={
          <CancelConfirmButtons
            disabledSubmit={isLoading || selectedRow?.realKey === 'telefono1'}
            disabledCancel={isLoading}
            isLoading={isLoading}
            onClickSubmit={editItem}
            onClickCancel={setClosePaymentDetail}
          />
        }
      />
    </>
  )
}

export default Contact
